(function () {
  'use strict';

  var CROPS = {
    cotton: 'fk-crop-cotton.jpg',
    tomato: 'fk-crop-tomato.jpg',
    wheat: 'fk-crop-wheat.jpg',
    paddy: 'fk-crop-paddy.jpg',
    soybean: 'fk-crop-soybean.jpg',
    onion: 'fk-crop-onion.jpg',
    sugarcane: 'fk-crop-sugarcane.jpg',
    chili: 'fk-crop-chili.jpg'
  };

  function getAssetBase() {
    var scripts = document.querySelectorAll('script[src*="/t/"][src*="/assets/"]');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].src.match(/(.*\/assets\/)/);
      if (m) return m[1];
    }
    return null;
  }

  function injectImages() {
    var base = getAssetBase();
    if (!base) return;

    document.querySelectorAll('.sbc__tile').forEach(function (tile) {
      var label = tile.getAttribute('aria-label') || '';
      var m = label.match(/^([A-Za-z]+) farming guide/i);
      if (!m) return;
      var crop = m[1].toLowerCase();
      var file = CROPS[crop];
      if (!file) return;

      var placeholder = tile.querySelector('.sbc__tile-placeholder');
      var img = tile.querySelector('.sbc__tile-img');
      var src = base + file;

      // Only inject for tiles using the emoji placeholder — tiles that already
      // have a server-rendered <img> (asset_url or image_url) are left alone
      // to avoid triggering a duplicate network request.
      if (placeholder) {
        var el = document.createElement('img');
        el.className = 'sbc__tile-img';
        el.src = src;
        el.alt = m[1] + ' crop — Farmkart';
        el.width = 600;
        el.height = 900;
        el.loading = 'lazy';
        placeholder.replaceWith(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectImages);
  } else {
    injectImages();
  }
})();
